import { store } from "../../..";
import { API } from "../../../../legacy/api";
import * as validate from "../../../validation";
import * as actions from "../../Theme/Common/Theme.actions";
import { ITheme } from "./Theme";

API.on("theme.reset", () => {
  store.dispatch(actions.resetTheme());
});

API.on("theme.set", (value: ITheme) => {
  if (validate.theme(value)) {
    store.dispatch(actions.setTheme(value));
  }
});
